module.exports = __webpack_public_path__ + "d0b4bb8afb0dc39f9832aa7c16b2ca64.jpg";